<template>
    <div :class="$style.wrapper">
        <h1 class="crumb">安装公司列表</h1>
        <div :class="$style.bar">
            <div :class="$style.btnGroup">
                <add--company :title="'添加安装公司'" :get_staff_position_list="get_staff_position_list"><el-button class="btn">添加安装公司</el-button></add--company>
            </div>
        </div>
        <div :class="$style.table">
            <el-table style="width: 100%" :data="tableData" size="small">
                <el-table-column align="center" label="公司名" prop="company_name"></el-table-column>
                <el-table-column align="center" label="公司简介" prop="company_profile" show-overflow-tooltip="true"></el-table-column>
                <el-table-column align="center" label="公司编号" prop="company_sn"></el-table-column>
                <el-table-column align="center" label="联系人" prop="company_contact"></el-table-column>
                <el-table-column align="center" label="联系方式" prop="company_tel"></el-table-column>
                <el-table-column align="center" label="备注" prop="remarks"></el-table-column>
                <el-table-column align="center" label="结算价格" prop="settlement_price"></el-table-column>
                <el-table-column align="center" label="公司地区" prop="diqu"></el-table-column>
                <el-table-column align="center" label="公司状态" prop="status_value"></el-table-column>
                <el-table-column align="center" label="添加时间" prop="addtime"></el-table-column>
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <a @click="modify(scope.row)">编辑</a>
                        <!--  <StaffForm
                         :title="'编辑员工'"
                         :scope='scope.row'
                         ><a>编辑</a></StaffForm> -->
                        <a style="margin: 0 3px;">|</a>
                        <a @click="deleat(scope.row)">删除</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 修改员工信息 -->
        <div clss='boxt'>
            <el-dialog
                :visible.sync="dialogFormVisible"
                :append-to-body="true"
                :custom-class="'dialogAddress'"
                title="添加安装公司"
            >
                <el-form ref="form" :rules="rules" :model="formData" >
                    <el-form-item label="公司名称：" prop="company_name">
                        <el-input v-model="formData.company_name"></el-input>
                    </el-form-item>
                    <el-form-item label="公司简介：" prop="company_profile">
                        <el-input :rows="3" type="textarea" placeholder="公司简介" v-model="formData.company_profile"></el-input>
                    </el-form-item>
                    <el-form-item label="公司编号：" prop="company_sn">
                        <el-input v-model="formData.company_sn"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人：" prop="company_contact">
                        <el-input v-model="formData.company_contact"></el-input>
                    </el-form-item>
                    <el-form-item label="联系方式：" prop="company_tel">
                        <el-input v-model="formData.company_tel"></el-input>
                    </el-form-item>
                    <el-form-item label="结算价格：" prop="settlement_price">
                        <el-input v-model="formData.settlement_price"></el-input>
                    </el-form-item>
                    <el-form-item class="address" label="公司地址：">
                        <el-select v-model="formData.province" placeholder="省份">
                            <el-option
                                v-for="{region_id, region_name} in provinceList"
                                :key="region_id"
                                :value="region_id"
                                :label="region_name"
                            >
                            </el-option>
                        </el-select>
                        <el-select v-model="formData.city" placeholder="城市">
                            <el-option
                                v-for="{region_id, region_name} in cityList"
                                :key="region_id"
                                :value="region_id"
                                :label="region_name"
                            ></el-option>
                        </el-select>
                        <el-select v-model="formData.district" placeholder="区">
                            <el-option
                                v-for="{region_id, region_name} in districtList"
                                :key="region_id"
                                :value="region_id"
                                :label="region_name"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="登录帐号：" prop="login_account">
                        <el-input v-model="formData.login_account"></el-input>
                    </el-form-item>
                    <el-form-item label="登录密码：" prop="login_password">
                        <el-input v-model="formData.login_password"></el-input>
                    </el-form-item>
                    <el-form-item label="备注：" prop="remarks">
                        <el-input v-model="formData.remarks"></el-input>
                    </el-form-item>
                    <el-form-item label="公司状态：" class="address" prop="status">
                        <el-select v-model="formData.status_value"  placeholder="公司状态">
                            <el-option value="0" label="正常"></el-option>
                            <el-option value="1" label="停用"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="changeAddr" :loading="btnLoading">确定
                        </el-button>
                        <el-button @click="dialogFormVisible=false">取消</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </div>
        <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage1"
            :page-size="10"
            layout=" total,prev, pager, next"
            :total="total">
        </el-pagination>
    </div>
</template>

<script>
    import { getAddressSelect, changeAddress, postAppointment, session_id } from '../../stores/api';
    import { mapState } from 'vuex';
    import Vue from 'vue';
    // import Pagination from '../Common/Pagination.vue';
    // import Confirm from '../Common/Confirm.vue';
    import AddCompany from './AddCompany';
    //
    Vue.component('Add-Company', AddCompany);
    // Vue.component('Confirm', Confirm);
    // Vue.component('StaffForm', StaffForm);
    export default {
        props: ['title', 'confirmText', 'handleSubmit','name','qunx','phone','password'],
        data () {

            return {
                formData:{},
                dialogFormVisible:false,
                formList:[],
                page:0,
                total:0,
                currentPage1:1,
                options: [],
                position_id: '',
                tableData: [],
                cityList: [],
                districtList: [],
                //dialog校验
                rules: {
                    company_name: [{required: true, message: '请输入公司名称', trigger: 'blur'}],
                    company_profile: [{required: true, message: '请输入公司简介', trigger: 'blur'}],
                    company_sn: [{required: true, message: '请输入公司编号', trigger: 'blur'}],
                    settlement_price: [{required: true, message: '请输入结算价格', trigger: 'blur'}],
                    company_contact: [{required: true, message: '请输入联系人', trigger: 'blur'}],
                    company_tel: [{required: true, message: '请输入公司联系方式', trigger: 'blur'}],
                    login_account: [{required: true, message: '请输入登录帐号', trigger: 'blur'}],
                    login_password: [{required: true, message: '请输入登录密码', trigger: 'blur'}],
                }
            };
        },
        watch: {
            'formData.province': async function (val, oldVal) {
               let id=val;
               let k='';
                this.provinceList.forEach((item,i)=>{
                    if(item.region_name===val){
                        id = item.region_id;
                        k=i
                    }
                })
                const data = await this.getCityList(id);
                if (data.length > 0) {
                    this.formData.city = data[0].region_id;
                }
            },
            // 'formData.province': async function (val, oldVal) {
            //     const data = await this.getCityList(val);
            //     if (data.length > 0) {
            //         this.formData.city = data[0].region_id;
            //     }
            // },
            'formData.city': async function (val, oldVal) {
                const data = await this.getDistrictList(val);
                if (data.length > 0) {
                    this.formData.district = data[0].region_id;
                }
            },
            async visible (val) {
                if (val) {
                    if (this.type === 1) {
                        this.getCityList(this.formData.province);
                        this.getDistrictList(this.formData.city);
                    } else {
                        const provinces = await this.getCityList(this.provinceList[0].region_id);
                        const districts = await this.getDistrictList(provinces[0].region_id);
                        this.formData.province = this.provinceList[0].region_id;
                        this.formData.city = provinces[0].region_id;
                        this.formData.district = districts[0].region_id;
                    }
                }
            }
            },
        computed: {
            ...mapState(['provinceList']),
        },
        methods:{
            async getCityList (id) {
                // console.log(this.provinceList);
                return getAddressSelect(id).then((res) => {
                    this.cityList = res.data;
                    return res.data;
                });
            },
            async getDistrictList (id) {
                return getAddressSelect(id).then(res => {
                    this.districtList = res.data;
                    return res.data;
                });
            },
            changeAddr () {
                this.$refs.form.validate(async (valid) => {
                    if (valid) {
                        // this.btnLoading = true;
                        if(this.formData.status_value==='正常'){
                            this.formData.status_value=0
                        }else{
                            this.formData.status_value=1
                        }
                        //&company_name=${self.company_name}&company_profile=${self.company_profile}&company_sn=${self.company_sn}&company_tel=${self.company_tel}&province=${self.province}&city=${self.city}&district=${self.district}&remarks=${self.remarks}&login_account=${self.login_account}&login_password=${self.login_password}&session_id=`+session_id
                        this.$http.get(this.$reqUrl + `service.php?act=company_insert&company_name=${this.formData.company_name}&company_profile=${this.formData.company_profile}&company_sn=${this.formData.company_sn}&company_contact=${this.formData.company_contact}&company_tel=${this.formData.company_tel}&province=${this.formData.province}&city=${this.formData.city}&district=${this.formData.district}&remarks=${this.formData.remarks}&login_account=${this.formData.login_account}&company_id=${this.formData.company_id}&status=${this.formData.status_value}&settlement_price=${this.formData.settlement_price}&login_password=${this.formData.login_password}&session_id=` + localStorage.getItem('shouhou_session_id')).then(res => {
                            if(0==res.data.error){
                                this.$message.success('添加成功')
                                // this.btnLoading = false;
                                this.dialogFormVisible = false;
                                this.get_staff_position_list()
                            }
                            if(1==res.data.error){
                                this.$message.error(res.data.msg)
                            }
                        }).catch(res => {
                            this.$message.error('请求失败')
                        })
                    }
                });
            },

            get_staff_position_list(page){
                this.$http.get(this.$reqUrl+`service.php?act=company_list&page=${this.page}&session_id=` + localStorage.getItem('shouhou_session_id'))
                    .then(res => {
                        console.log(res.data);
                        this.tableData = res.data.company_list;
                        this.total = res.data.count
                        this.tableData.forEach((item,i) => {
                            this.tableData[i]['diqu'] = res.data.company_list[i].province+'-'+res.data.company_list[i].city+'-'+res.data.company_list[i].district
                        })
                        // for(let i=0;i<res.data.staff_list.length;i++){
                        //     this.tableData[i].avatar='http://shop.gzestars.com'+res.data.staff_list[i].avatar
                        // }
                    })
            },
            handleCurrentChange(val){
                this.page = val;
                this.get_staff_position_list(this.page);
            },
            //删除员工
            deleat(row) {
                console.log(row)
                this.$confirm('是否删除该安装公司?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    this.$http.get(this.$reqUrl + 'service.php?act=company_del&session_id=' + localStorage.getItem('shouhou_session_id') + '&company_id=' + row.company_id).then(res => {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.get_staff_position_list(this.page)
                        })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            //编辑员工信息
            modify(row) {
                console.log(row)
                this.formData=row
                this.dialogFormVisible=true;
                this.formList=row;
            },
            //确定修改
            suremodify(page){
                this.$http.get(this.$reqUrl+'user.php?act=update_staff&session_id='+session_id,{params: this.formList})
                    .then(res=>{
                        this.dialogFormVisible=false;
                        this.get_staff_position_list(page);
                        this.$message({
                            type: 'success',
                            message: '编辑成功!'
                        });
                    })
            },
            //获取职位列表
            getzw(){
                this.$http.get(this.$reqUrl+'user.php?act=get_staff_position_list&content='+1+'&session_id='+session_id)
                    .then(res=>{
                        this.options=res.data.position_nav;
                        for(let i=0;i<res.data.position_nav.length;i++){
                            this.options = res.data.position_nav.map(item => {
                                return {value: item.position_id, label: item.position_name};
                            });
                        }
                    })
            }

        },
        mounted(){
            //获取员工信息列表
            this.get_staff_position_list();
            this.getzw();
        }
    };
</script>

<style lang="less" module>
    .wrapper {
        .bar {
            display: flex;
            justify-content: space-between;
            margin-bottom: 15px;
            .btnGroup {
                button {
                    width: 100Px;
                    height: 35Px;
                    margin-right: 10Px;
                    font-size: 16px;
                    color: #ffffff;
                    background: #f56c31;
                    border-radius: 2px;
                }
            }
            .search {
                display: flex;
                input {
                    width: 300px;
                    border-radius: 0;
                    border: 1px solid #d8dde6;
                    border-right: 0;
                }
                button {
                    border-radius: 0;
                }
            }
        }

        .table {
            border:1px solid #d8dde6;
            .avatar {
                vertical-align: middle;
                margin: 10px 10px;
                border-radius: 50%;
            }
        }

    }
</style>
<style>
    .el-dialog{
        width: 500px;
        margin: 0 auto 50px;
    }
    .bosform{
        padding: 30Px 90Px 30Px 70Px;
    }
    .bosform .el-input{
        width: 260px;
        height: 32px;
    }
    .el-dialog__body{
        padding:0;
    }
    .boxt .el-form-item--mini.el-form-item, .boxt .el-form-item--small.el-form-item{
        margin-bottom: 18px;
    }
    .boxt .el-form-item__content{
        margin-left:80px;
    }
    .el-dialog__body {
        padding-bottom: 30Px ;
        text-align: center;
    }
    .el-dialog__body input{
        border-radius: 0;
    }
    .el-table th>.cell{
        color:#ea6625;
    }
    .yx-popover-btn {
        margin-top: 10PX;
        width:120Px;
        height:35Px;
        font-size:16px;
        color:#ffffff;
        border-radius:4px;
    }
    .yx-popover-cancelBtn {
        margin-left: 10px;
        background:#d8dde6;
    }
</style>



// WEBPACK FOOTER //
// src/components/InstallationCompany/CompanyList.vue